import {
  POST_FAVORITE,
  DELETE_FAVORITE,
  DELETE_ALL_FAVORITES
} from "@/libvue/apps/catalog/favorites/actions";

import { mapState, mapGetters } from "vuex";

const favoritesMixin = {
  data() {
    return {
      favoriteActions: [
        {
          callback: this.removeFromFavorites.bind(),
          displayName: "Edit Segments",
          disabled: true
        },
        {
          callback: this.removeFromFavorites.bind(),
          displayName: "Duplicate",
          disabled: true
        },
        {
          callback: this.removeFromFavorites.bind(),
          displayName: "Remove from Bookmarks",
          disabled: false
        }
      ],
      favoriteBatchActions: []
    };
  },
  computed: {
    ...mapState({
      favorites: (state) => state.favorites.list
    }),
    ...mapGetters(["getUserUID"]),
    items() {
      return {
        ...this.favorites,
        data: {
          ...this.favorites?.data,
          results: this.favorites?.data?.results?.map((f) => f.item)
        }
      };
    }
  },
  methods: {
    addToFavorites(fav) {
      return this.$store
        .dispatch(POST_FAVORITE, fav)
        .then(() => {
          this.$notify.success(this.t("catalog.favorites.add_success"));
        })
        .catch(() => {
          this.$notify.danger(this.t("catalog.favorites.add_error"));
        });
    },
    removeFromFavorites(fav) {
      return this.$store
        .dispatch(DELETE_FAVORITE, fav)
        .then(() => {
          this.$notify.success(this.t("catalog.favorites.remove_success"));
        })
        .catch(() => {
          this.$notify.danger(this.t("catalog.favorites.remove_error"));
        });
    },
    removeAllFromFavorites() {
      return this.$store.dispatch(DELETE_ALL_FAVORITES);
    },
    toggleCheck(checked, item) {
      this.multiselected = {
        context: "favorites",
        value: item,
        checked
      };
    }
  }
};
export { favoritesMixin };
